import { CertificateDto } from './certificate.dto';

export class Certificate {
    readonly id: string;
    readonly courseId: string;
    readonly courseName: string;

    constructor(dto: CertificateDto) {
        this.id = dto.id;
        this.courseId = dto.courseId;
        this.courseName = dto.courseName;
    }
}
